// src/hooks/useAdminData.js
import { useState, useEffect, useCallback } from "react";
import { adminService } from "../services/admin.service";

/**
 * Encapsulates all admin dashboard data fetching.
 * Only fetches when authData.role === "Admin".
 */
export function useAdminData(authData, logout) {
  const [companies, setCompanies] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [adminLoading, setAdminLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!authData || authData.role !== "Admin") return;
    setAdminLoading(true);
    try {
      const [companiesData, statsData] = await Promise.all([
        adminService.getCompanies(),
        adminService.getStatistics(),
      ]);
      setCompanies(Array.isArray(companiesData) ? companiesData : []);
      setStatistics(statsData ?? null);
    } catch (e) {
      if (e?.message === "UNAUTHORIZED") {
        logout?.();
      }
      // Other errors are silent here — callers that need error UI handle them.
    } finally {
      setAdminLoading(false);
    }
  }, [authData, logout]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { companies, setCompanies, statistics, setStatistics, adminLoading, reload };
}
